(ns kyber.kyber-db.learning-objective)

(def model
  {:ident-key
   :learning-objective/uuid

   :schema
   #:learning-objective
   {:uuid
    {:doc "UIUD of the learning objective"}}})
